import jwtDecode from 'jwt-decode';
import { msalAuthRedirect } from 'portal-utils/AzureConnect';

import config from '../utils/getEnv';
import { updateAxiosInstance } from '../api/axiosInstance';
import { updateFetchTokenHandler } from '../api/fetchInstance';
import { accessAnalyticsCode } from '../utils/firebaseConfig';

// eslint-disable-next-line import/no-mutable-exports
export let impersonatedUserName = null;

const auth = msalAuthRedirect.auth(config);
export const {
  logout,
  getUser,
  impersonateRedirect,
  getUserId,
  getUserEmail,
  getUserIdp,
  getLastLogonTime,
  getImpersonatedDisplayName,
  getLoggedUserEmailId,
  getUserLastName,
} = auth;

let currentTokenExp = 0; // seconds since epoch (matches JWT `exp`)
const EXPIRY_SKEW_SECONDS = 30; // treat as expired slightly early

const captureExpiry = token => {
  try {
    const { exp } = jwtDecode(token);
    currentTokenExp = typeof exp === 'number' ? exp : 0;
  } catch (e) {
    currentTokenExp = 0;
  }
};

/**
 * Pure validity check — returns true iff we currently hold a token whose
 * `exp` claim is in the future (with a small skew). No side effects, never
 * calls logout, safe to invoke from synchronous code paths (request
 * interceptors, render code, etc.).
 */
export const isValidToken = () => {
  if (!currentTokenExp) return false;
  const nowSec = Math.floor(Date.now() / 1000);
  return currentTokenExp - EXPIRY_SKEW_SECONDS > nowSec;
};

// Thin wrapper around auth.getToken so every successful acquisition
// (initial login + every silent refresh triggered from axios/fetch)
// refreshes `currentTokenExp`. The axios/fetch refresh paths use this as
// their `loginHandler`.
const acquireToken = () =>
  auth.getToken().then(token => {
    if (token) captureExpiry(token);
    return token;
  });

export const loginUser = () =>
  acquireToken().then(token => {
    accessAnalyticsCode();
    updateAxiosInstance(token, acquireToken, isValidToken);
    updateFetchTokenHandler(token, acquireToken, isValidToken);
    impersonatedUserName = auth.getImpersonatedDisplayName();
    return token;
  });

// In case of impersonatePopup change the token for axios here
// For impersonateRedirect, it will be same as acquiretokenredirect flow
// export const impersonatePopup = () =>
//   auth.impersonateUser().then((res) => {
//     impersonatedUserName = res.impersonatedUser;
//     // change axios token here
//     updateAxiosInstance(res.token, logout, isValidToken);
//     console.log("token", res.token);
//     return res;
//   });
